export const registerFrameListener = (el) => el.__ref.__root.data.frameStack?.push(el)
